/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plain_Text_Import_Start_Event_Char_LabelInputs */

const en_plain_text_import_start_event_char_label = /** @type {(inputs: Plain_Text_Import_Start_Event_Char_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start Event On Character`)
};

const fr_plain_text_import_start_event_char_label = /** @type {(inputs: Plain_Text_Import_Start_Event_Char_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demarrer l'evenement sur caractere`)
};

const de_plain_text_import_start_event_char_label = /** @type {(inputs: Plain_Text_Import_Start_Event_Char_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignis mit Charakter starten`)
};

const it_plain_text_import_start_event_char_label = /** @type {(inputs: Plain_Text_Import_Start_Event_Char_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avvia evento sul personaggio`)
};

const ru_plain_text_import_start_event_char_label = /** @type {(inputs: Plain_Text_Import_Start_Event_Char_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начало события для персонажа`)
};

const es_plain_text_import_start_event_char_label = /** @type {(inputs: Plain_Text_Import_Start_Event_Char_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar evento en el personaje`)
};

const zh_cn2_plain_text_import_start_event_char_label = /** @type {(inputs: Plain_Text_Import_Start_Event_Char_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`角色开始事件`)
};

const ja_plain_text_import_start_event_char_label = /** @type {(inputs: Plain_Text_Import_Start_Event_Char_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャラクターのイベント開始`)
};

const hi_plain_text_import_start_event_char_label = /** @type {(inputs: Plain_Text_Import_Start_Event_Char_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चरित्र पर घटना प्रारंभ करें`)
};

const pt_pt2_plain_text_import_start_event_char_label = /** @type {(inputs: Plain_Text_Import_Start_Event_Char_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar evento no personagem`)
};

/**
* | output |
* | --- |
* | "Start Event On Character" |
*
* @param {Plain_Text_Import_Start_Event_Char_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_start_event_char_label = /** @type {((inputs?: Plain_Text_Import_Start_Event_Char_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_Start_Event_Char_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_plain_text_import_start_event_char_label(inputs)
	if (locale === "de") return de_plain_text_import_start_event_char_label(inputs)
	if (locale === "it") return it_plain_text_import_start_event_char_label(inputs)
	if (locale === "ru") return ru_plain_text_import_start_event_char_label(inputs)
	if (locale === "es") return es_plain_text_import_start_event_char_label(inputs)
	if (locale === "zh-CN") return zh_cn2_plain_text_import_start_event_char_label(inputs)
	if (locale === "ja") return ja_plain_text_import_start_event_char_label(inputs)
	if (locale === "hi") return hi_plain_text_import_start_event_char_label(inputs)
	if (locale === "pt-PT") return pt_pt2_plain_text_import_start_event_char_label(inputs)
	return en_plain_text_import_start_event_char_label(inputs)
});